import SafeUncontrolledPopover from 'components/SafeUncontrolledPopover';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { CalibrationOriginalItem, Question } from 'types';
import { v4 as uuidv4 } from 'uuid';
import CalibrationHistoryItems from 'views/Widgets/Dashboards/TeamDashboard/Calibration/CalibrationHistoryItems';
import { CalibrationHistory } from './utils';

type Props = {
  calibrationHistory: CalibrationHistory;
  question: Question;
};

const PerformanceWrittenResponseCalibrationHistory: React.FC<Props> = ({
  calibrationHistory,
  question,
}) => {
  const id = useMemo(() => 'calibration-popover-' + uuidv4(), []);

  const originalResponses: CalibrationOriginalItem[] = useMemo(() => {
    return [
      {
        value: calibrationHistory.original.value,
        author: calibrationHistory.original.author,
        priority: 0,
      },
    ];
  }, [calibrationHistory.original]);

  return (
    <>
      <Row className="mt-2 px-0">
        <Col className="text-end">
          <span
            id={id}
            role="button"
            className="py-2 badge rounded-pill bg-warning-soft text-uppercase badge bg-secondary rounded-pill"
          >
            <i className="fe fe-lock me-2"></i>
            <span className="text-primary">
              <FormattedMessage
                id="app.views.person.person_performance.performance_written_response.view_calibration_history"
                defaultMessage="Calibration history"
              />
            </span>
          </span>
        </Col>
      </Row>
      <SafeUncontrolledPopover
        className="popover-variable-lg"
        target={id}
        trigger="hover click"
        placement="right"
      >
        <CalibrationHistoryItems
          calibrationItems={calibrationHistory.history}
          question={question}
          originalResponses={originalResponses}
        />
      </SafeUncontrolledPopover>
    </>
  );
};

export default React.memo(PerformanceWrittenResponseCalibrationHistory);
